var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "leave-active-class": "duration-200"
    }
  }, [_vm.showing === true && _vm.loadingData === false ? _c('div', {
    staticClass: "z-50 fixed bottom-0 px-4 inset-0 sm:p-0 flex items-center justify-center",
    on: {
      "keydown": function ($event) {
        return _vm.$refs.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.$refs.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_c('div', {
    staticClass: "fixed inset-0 transition-opacity",
    on: {
      "click": function ($event) {
        return _vm.closePopup();
      }
    }
  }, [_c('div', {
    staticClass: "absolute inset-0 bg-indigo-600 bg-opacity-85"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bg-white rounded-lg px-4 pt-5 pb-4 overflow-scroll max-h-9/10 shadow-xl transform transition-all lg:w-4/6 sm:w-full sm:p-6",
    attrs: {
      "aria-labelledby": "modal-headline",
      "aria-modal": "true",
      "role": "dialog"
    },
    on: {
      "scroll": function ($event) {
        return _vm.$refs.progressbar.reduceProgressBar($event);
      }
    }
  }, [_c('div', {
    staticClass: "cursor-pointer absolute right-5 top-20 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600",
    on: {
      "click": function ($event) {
        return _vm.closePopup();
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sticky top-0 z-10"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.messageHeader.type != '' && _vm.messageHeader.msg != '' ? _c('div', {
    staticClass: "absolute text-center py-5 mt-10 w-6/12 left-3/12 right-3/12 text-base flex items-center justify-center",
    class: {
      'bg-green-300 border-2 border-green-600 border-opacity-25 text-green-600': _vm.messageHeader == 'saveIsSuccess' || _vm.messageHeader == 'transferIsSuccess',
      'bg-pink-300 border-2 border-pink-600 border-opacity-25 text-pink-600': _vm.messageHeader == 'error' || _vm.messageHeader == 'noName' || _vm.messageHeader == 'lastActivity' || _vm.messageHeader === 'evaluationInProgress',
      'bg-amber-100 border-2 border-amber-600 border-opacity-25 text-amber-600': _vm.messageHeader == 'noSave'
    }
  }, [_c('div', [_c('div', {
    staticClass: "flex items-center justify-center"
  }, [_vm.messageHeader == 'saveIsSuccess' || _vm.messageHeader == 'transferIsSuccess' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "checkmark-circle-2"
    }
  }) : _vm.messageHeader == 'error' || _vm.messageHeader == 'noName' || _vm.messageHeader == 'lastActivity' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "alert-triangle"
    }
  }) : _vm.messageHeader == 'noSave' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "alert-triangle"
    }
  }) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'saveIsSuccess' ? _c('div', [_vm._v("\n                  Vos données ont été enregistrées.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'transferIsSuccess' ? _c('div', [_vm._v("\n                  La fiche de poste à bien été transférée.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'evaluationInProgress' ? _c('div', [_vm._v("\n                  Vous ne pouvez pas modifier une fiche de poste utilisée par\n                  une évaluation.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'error' ? _c('div', [_vm._v("\n                  Erreur d'enregistrement des données.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'lastActivity' ? _c('div', [_vm._v("\n                  Vous ne pouvez pas supprimer la dernière activité.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'noName' ? _c('div', [_vm._v("\n                  Veuillez remplir le champ \"nom du poste\"\n                  "), _c('br'), _vm._v("\n                  pour enregistrer la fiche.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'noSave' ? _c('div', [_vm._v("\n                  Vous avez des modifications non sauvegardées."), _c('br')]) : _vm._e()], 1), _vm._v(" "), _vm.messageHeader == 'noSave' ? _c('div', {
    staticClass: "mt-5"
  }, [_c('button', {
    staticClass: "border-amber-600 border-opacity-25 text-amber-600 bg-amber-100 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2 mr-4",
    on: {
      "click": function ($event) {
        return _vm.cancel_nosave();
      }
    }
  }, [_vm._v("\n                  ANNULER\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "bg-amber-600 text-amber-100 border-amber-100 border-opacity-25 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2",
    on: {
      "click": function ($event) {
        return _vm.closeWithoutSaving();
      }
    }
  }, [_vm._v("\n                  QUITTER\n                ")])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _vm.editable && (_vm.$can(_vm.constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER) || _vm.$can(_vm.constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER)) ? _c('div', {
    staticClass: "absolute right-15 mt-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14",
    on: {
      "click": _vm.save_datas
    }
  }, [_c('icon', {
    staticClass: "h-6 w-6 ml-4 mt-1/4",
    attrs: {
      "name": "save"
    }
  })], 1) : !_vm.editable && _vm.$can(_vm.constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_EDITER) || _vm.$can(_vm.constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_EDITER) ? _c('div', {
    staticClass: "absolute right-15 mt-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14",
    on: {
      "click": _vm.save_datas
    }
  }, [_c('icon', {
    staticClass: "h-6 w-6 ml-4 mt-1/4",
    attrs: {
      "name": "save"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _vm.editable ? _c('progress-bar', {
    ref: "progressbar",
    attrs: {
      "in-popup": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-5 md:mx-15 md:mt-15 md:mb-0 grid grid-cols-12"
  }, [_c('h3', {
    staticClass: "col-span-full"
  }, [_vm._v("\n          " + _vm._s(_vm.form.nom_du_poste) + "\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "col-span-full text-indigo-600 my-10"
  }, [_vm._v("\n          Informations de base\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full grid grid-cols-12 gap-4"
  }, [_c('input-text', {
    class: 'lg:col-span-4',
    attrs: {
      "name": "nom_du_poste",
      "libelle": "Nom du poste",
      "necessary": true,
      "value": _vm.form.nom_du_poste,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.nom_du_poste = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "sector",
      "libelle": "Secteur d'activité",
      "necessary": true,
      "datas": _vm.categories,
      "value": _vm.form.sector,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.sector = newValue;
        _vm.setIndex(newValue);
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "family",
      "libelle": "Famille professionnelle",
      "necessary": true,
      "value": _vm.form.family,
      "datas": _vm.listDomaines,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.family = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "definition",
      "libelle": "Définition",
      "size": 5,
      "necessary": true,
      "value": _vm.form.definition,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.definition = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "acces_emploi",
      "libelle": "Accès à l'emploi métier",
      "size": 5,
      "necessary": true,
      "value": _vm.form.acces_emploi,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.acces_emploi = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "conditions_exercice",
      "libelle": "Conditions d'exercice de l'activité",
      "size": 5,
      "necessary": true,
      "value": _vm.form.conditions_exercice,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.conditions_exercice = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "emplois_proches",
      "libelle": "Mobilité : Emplois proches",
      "size": 5,
      "necessary": true,
      "value": _vm.form.emplois_proches,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.emplois_proches = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "evolutions",
      "libelle": "Mobilité : Emplois si évolution",
      "size": 5,
      "necessary": true,
      "value": _vm.form.evolutions,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.evolutions = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full grid grid-cols-12 gap-4 my-10"
  }, [_c('h4', {
    staticClass: "text-indigo-600 col-span-full"
  }, [_vm._v("\n              Référentiels correspondants\n            ")]), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "name": "rome",
      "libelle": "ROME",
      "necessary": false,
      "value": _vm.form.rome,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.rome = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "name": "rsfp",
      "libelle": "RSFP",
      "necessary": false,
      "value": _vm.form.rsfp,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.rsfp = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "name": "rncp",
      "libelle": "Diplômes et titre (RNCP)",
      "necessary": false,
      "value": _vm.form.rncp,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.rncp = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "name": "convention_collective",
      "libelle": "Conventions collectives",
      "necessary": false,
      "value": _vm.form.convention_collective,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.convention_collective = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "relative col-span-full"
  }, [_c('div', {
    staticClass: "my-10"
  }, [_c('div', {
    staticClass: "w-full flex flex-col justify-center items-center mb-10"
  }, [_c('div', {
    staticClass: "max-w-8/10 flex flex-col items-end"
  }, [_c('div', {
    staticClass: "flex flex-row justify-center items-center cursor-pointer w-full",
    on: {
      "click": [_vm.displayTypeCompetenceslist, function ($event) {
        $event.stopPropagation();
      }]
    }
  }, [_c('div', {
    staticClass: "flex flex-row items-end justify-center ml-2"
  }, [_c('h4', {
    staticClass: "text-indigo-600 text-center select-none"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentTypeCompetence) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-pink-600 max-h-8 rounded-full relative flex items-center p-2 order-2"
  }, [_c('icon', {
    staticClass: "h-4 w-4",
    attrs: {
      "name": "chevron-down"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "activitylist relative h-0"
  }, [_vm.showList ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.displayTypeCompetenceslist,
      expression: "displayTypeCompetenceslist"
    }],
    staticClass: "absolute w-max flex z-20 rounded-md bg-white shadow-md shadow-gray-600 text-sm right-0"
  }, [_c('div', {
    staticClass: "mx-5 my-3"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('div', {
    staticClass: "first:pt-2 py-1"
  }, [_c('p', {
    staticClass: "text-gray-600 hover:text-gray-900 cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.currentTypeCompetence = 'Compétences de base';
        _vm.displayTypeCompetenceslist();
      }
    }
  }, [_vm._v("\n                              Compétences de base\n                            ")]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-600 hover:text-gray-900 cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.currentTypeCompetence = 'Compétences spécifiques';
        _vm.displayTypeCompetenceslist();
      }
    }
  }, [_vm._v("\n                              Compétences spécifiques\n                            ")])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentTypeCompetence === 'Compétences de base',
      expression: "currentTypeCompetence === 'Compétences de base'"
    }]
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-y-5 gap-x-10 mb-10"
  }, [_c('h5', {
    staticClass: "text-left text-base uppercase text-indigo-600 col-span-full"
  }, [_vm._v("\n                    Savoir-faire\n                  ")]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "col-span-full grid grid-cols-12 gap-y-5 gap-x-10",
    on: {
      "start": function ($event) {
        _vm.drag = true;
      },
      "end": function ($event) {
        _vm.drag = false;
      }
    },
    model: {
      value: _vm.form.competences_bases.savoir_faire,
      callback: function ($$v) {
        _vm.$set(_vm.form.competences_bases, "savoir_faire", $$v);
      },
      expression: "form.competences_bases.savoir_faire"
    }
  }, 'draggable', _vm.dragOptions, false), _vm._l(_vm.form.competences_bases.savoir_faire, function (sf, isf) {
    return _c('div', {
      key: 'A' + isf,
      staticClass: "col-span-6 flex items-center relative"
    }, [_c('input-text-with-action', {
      class: {
        'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50': _vm.isFlash.sf == _vm.index
      },
      style: _vm.editable ? 'cursor:grab' : '',
      attrs: {
        "libelle": "",
        "name": 'sf' + isf,
        "necessary": true,
        "value": sf,
        "disabled": !_vm.editable,
        "is-grabable": true,
        "draggable": true,
        "placeholder": "Saisir le nom du savoir-faire",
        "prefix-text": isf + 1 + '. '
      },
      on: {
        "input": function (newValue) {
          sf = newValue;
        },
        "switchDraggable": function (newValue) {
          _vm.isDraggable = newValue;
        },
        "duplicate": function ($event) {
          return _vm.duplicateSavoirFaire(sf, isf, 'competences_bases');
        },
        "delete": function ($event) {
          return _vm.deleteFromCompetence(_vm.form.competences_bases.savoir_faire, isf);
        }
      }
    })], 1);
  }), 0), _vm._v(" "), _c('add-button', {
    staticClass: "col-span-full flex items-center w-max",
    attrs: {
      "libelle": "Ajouter un savoir-faire",
      "disabled": !_vm.editable
    },
    on: {
      "add": function ($event) {
        return _vm.addToCompetence(_vm.form.competences_bases.savoir_faire);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-y-5 gap-x-10 mb-10"
  }, [_c('h5', {
    staticClass: "text-left text-base uppercase text-indigo-600 col-span-full"
  }, [_vm._v("\n                    Savoirs\n                  ")]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "col-span-full grid grid-cols-12 gap-y-5 gap-x-10",
    on: {
      "start": function ($event) {
        _vm.drag = true;
      },
      "end": function ($event) {
        _vm.drag = false;
      }
    },
    model: {
      value: _vm.form.competences_bases.savoirs,
      callback: function ($$v) {
        _vm.$set(_vm.form.competences_bases, "savoirs", $$v);
      },
      expression: "form.competences_bases.savoirs"
    }
  }, 'draggable', _vm.dragOptions, false), _vm._l(_vm.form.competences_bases.savoirs, function (savoir, is) {
    return _c('div', {
      key: 'A' + is,
      staticClass: "col-span-6 flex items-center relative"
    }, [_c('input-text-with-action', {
      class: {
        'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50': _vm.isFlash.sf == _vm.index
      },
      style: _vm.editable ? 'cursor:grab' : '',
      attrs: {
        "libelle": "",
        "name": 'savoir' + is,
        "necessary": true,
        "value": savoir,
        "disabled": !_vm.editable,
        "is-grabable": true,
        "draggable": true,
        "placeholder": "Saisir le nom du savoir",
        "prefix-text": is + 1 + '. '
      },
      on: {
        "input": function (newValue) {
          savoir = newValue;
        },
        "switchDraggable": function (newValue) {
          _vm.isDraggable = newValue;
        },
        "duplicate": function ($event) {
          return _vm.duplicateSavoir(savoir, is, 'competences_bases');
        },
        "delete": function ($event) {
          return _vm.deleteFromCompetence(_vm.form.competences_bases.savoirs, is);
        }
      }
    })], 1);
  }), 0), _vm._v(" "), _c('add-button', {
    staticClass: "col-span-full flex items-center w-max",
    attrs: {
      "libelle": "Ajouter un savoir",
      "disabled": !_vm.editable
    },
    on: {
      "add": function ($event) {
        return _vm.addToCompetence(_vm.form.competences_bases.savoirs);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentTypeCompetence === 'Compétences spécifiques',
      expression: "currentTypeCompetence === 'Compétences spécifiques'"
    }]
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-y-5 gap-x-10 mb-10"
  }, [_c('h5', {
    staticClass: "text-left text-base uppercase text-indigo-600 col-span-full"
  }, [_vm._v("\n                    Savoir-faire\n                  ")]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "col-span-full grid grid-cols-12 gap-y-5 gap-x-10",
    on: {
      "start": function ($event) {
        _vm.drag = true;
      },
      "end": function ($event) {
        _vm.drag = false;
      }
    },
    model: {
      value: _vm.form.competences_spe.savoir_faire,
      callback: function ($$v) {
        _vm.$set(_vm.form.competences_spe, "savoir_faire", $$v);
      },
      expression: "form.competences_spe.savoir_faire"
    }
  }, 'draggable', _vm.dragOptions, false), _vm._l(_vm.form.competences_spe.savoir_faire, function (sf, isf) {
    return _c('div', {
      key: 'A' + isf,
      staticClass: "col-span-6 flex items-center relative"
    }, [_c('input-text-with-action', {
      class: {
        'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50': _vm.isFlash.sf == _vm.index
      },
      style: _vm.editable ? 'cursor:grab' : '',
      attrs: {
        "libelle": "",
        "name": 'sf' + isf,
        "necessary": true,
        "value": sf,
        "disabled": !_vm.editable,
        "is-grabable": true,
        "draggable": true,
        "placeholder": "Saisir le nom du savoir-faire",
        "prefix-text": isf + 1 + '. '
      },
      on: {
        "input": function (newValue) {
          sf = newValue;
        },
        "switchDraggable": function (newValue) {
          _vm.isDraggable = newValue;
        },
        "duplicate": function ($event) {
          return _vm.duplicateSavoirFaire(sf, isf, 'competences_spe');
        },
        "delete": function ($event) {
          return _vm.deleteFromCompetence(_vm.form.competences_spe.savoir_faire, isf);
        }
      }
    })], 1);
  }), 0), _vm._v(" "), _c('add-button', {
    staticClass: "col-span-full flex items-center w-max",
    attrs: {
      "libelle": "Ajouter un savoir-faire",
      "disabled": !_vm.editable
    },
    on: {
      "add": function ($event) {
        return _vm.addToCompetence(_vm.form.competences_spe.savoir_faire);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-y-5 gap-x-10 mb-10"
  }, [_c('h5', {
    staticClass: "text-left text-base uppercase text-indigo-600 col-span-full"
  }, [_vm._v("\n                    Savoirs\n                  ")]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "col-span-full grid grid-cols-12 gap-y-5 gap-x-10",
    on: {
      "start": function ($event) {
        _vm.drag = true;
      },
      "end": function ($event) {
        _vm.drag = false;
      }
    },
    model: {
      value: _vm.form.competences_spe.savoirs,
      callback: function ($$v) {
        _vm.$set(_vm.form.competences_spe, "savoirs", $$v);
      },
      expression: "form.competences_spe.savoirs"
    }
  }, 'draggable', _vm.dragOptions, false), _vm._l(_vm.form.competences_spe.savoirs, function (savoir, is) {
    return _c('div', {
      key: 'A' + is,
      staticClass: "col-span-6 flex items-center relative"
    }, [_c('input-text-with-action', {
      class: {
        'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50': _vm.isFlash.sf == _vm.index
      },
      style: _vm.editable ? 'cursor:grab' : '',
      attrs: {
        "libelle": "",
        "name": 'savoir' + is,
        "necessary": true,
        "value": savoir,
        "disabled": !_vm.editable,
        "is-grabable": true,
        "draggable": true,
        "placeholder": "Saisir le nom du savoir",
        "prefix-text": is + 1 + '. '
      },
      on: {
        "input": function (newValue) {
          savoir = newValue;
        },
        "switchDraggable": function (newValue) {
          _vm.isDraggable = newValue;
        },
        "duplicate": function ($event) {
          return _vm.duplicateSavoir(savoir, is, 'competences_spe');
        },
        "delete": function ($event) {
          return _vm.deleteFromCompetence(_vm.form.competences_spe.savoirs, is);
        }
      }
    })], 1);
  }), 0), _vm._v(" "), _c('add-button', {
    staticClass: "col-span-full flex items-center w-max",
    attrs: {
      "libelle": "Ajouter un savoir",
      "disabled": !_vm.editable
    },
    on: {
      "add": function ($event) {
        return _vm.addToCompetence(_vm.form.competences_spe.savoirs);
      }
    }
  })], 1)])])])], 1), _vm._v(" "), _c('p', {
    staticClass: "col-span-full text-center mt-10 text-sm font-light italic"
  }, [_vm._v("\n          Pôle Emploi - Données originales téléchargées via l'API\n          "), _c('a', {
    attrs: {
      "href": "https://francetravail.io/produits-partages/catalogue/rome-4-0-competences",
      "target": "_blank"
    }
  }, [_vm._v("ROME")])])])], 1)], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }